export const ingredientsMetadata = {
  'peg7-dimethicone': {
    description:
      'PEG-7 Dimethicone is known for detangling and softening hair. Learn more about PEG-7 Dimethicone for hair and which Prose products contain this ingredient.',
    title: 'PEG-7 Dimethicone for Hair - Ingredient Glossary | Prose',
  },
  'provitamin-b5': {
    description:
      'Pro-Vitamin B5 is known for it’s scalp-soothing and hydration in hair. Learn more about Pro-Vitamin B5 for hair and which Prose products contain this ingredient.',
    title: 'Pro-Vitamin B5 for Hair - Ingredient Glossary | Prose',
  },
};
